const { constants } = window.__litium

export default constants

export const uniqueCountryLangPairs =
    constants && Array.isArray(constants.countryLanguagePairs)
        ? constants.countryLanguagePairs.reduce(
              (o, x) => ({
                  ...o,
                  [x.attributes.alpha2]: {
                      // TODO -- migrate to use only 'label'
                      text: x.text.split(' (')[0],
                      label: x.text.split(' (')[0],
                      value: x.attributes.alpha2,
                      href: x.href,
                      imgSrc: x.attributes.imgSrc,
                  },
              }),
              {}
          )
        : {}
